<template>
  <div class="tw-flex tw-items-center tw-gap-2 tw-w-full">
    <InputField
      @update:modelValue="handleInput"
      :modelValue="modelValue"
      class="tw-flex-1"
      :placeholder="placeholder"
      :largeWidth="true"
      :enableCancel="true"
    ></InputField>

    <button 
      v-if="modelValue && modelValue.length > 0" 
      @click="clearInput" 
      class="tw-inline-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-backdrop-blur tw-text-slate-700 hover:tw-bg-white"
      type="button"
      aria-label="Clear"
    >
      <font-awesome-icon icon="xmark" class="tw-h-4 tw-w-4" />
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import InputField from './Input/InputField.vue';

export default defineComponent({
  name: 'SearchInput',
  components: {
    InputField: InputField as any,
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: String
  },
  emits: ['update:modelValue', 'search'],
  data() {
    return {
      timer: null,
    };
  },
  methods: {
    handleInput(val: string) {
      const vm = (this as any);

      vm.$emit('update:modelValue', val);

      if (vm.timer) {
        clearTimeout(vm.timer);
      }

      vm.timer = setTimeout(() => {
        vm.$emit('search', val);
      }, 350);
    },
    clearInput() {
      (this as any).handleInput('');
    },
  },
});
</script>